<p-confirmDialog key="email" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Form-->
<div class="MainForm">
	<label>Recipients (Seperate multiple with ;):</label>
	<input [(ngModel)]="Recipients" class="form-control" type="text" placeholder="example@Example.com;test@Access411.com" />

	<label>Message:</label>
	<textarea [(ngModel)]="Message" class="TextArea" rows="10"></textarea>

	<label>Using HTML?:</label>
	<input [(ngModel)]="UsingHTML" class="form-control" type="checkbox" />

	<label>Subject:</label>
	<input [(ngModel)]="Subject" class="form-control" type="text" />

	<label>From Email:</label>
	<input [(ngModel)]="FromEmail" class="form-control" type="text" />

	<!-- <label>Attachments:</label>
    <input class="form-control" type="text">
     -->
</div>

<div class="SubGrid">
	<div class="InfoGrid">
		<label>SQL Method:</label>
		<label class="InfoText">usp_ServerEmailSend</label>

		<label>Preference KeyName:</label>
		<label class="InfoText">DefaultEmail</label>

		<label>Version:</label>
		<label class="InfoText">New</label>
	</div>

	<div class="Buttons">
		<button class="btn btn-primary" (click)="onSendEmail()">Send Email</button>
	</div>
</div>

<div class="SubGrid">
	<div class="InfoGrid">
		<label>SQL Method:</label>
		<label class="InfoText">usp_ServerNotificationSend</label>

		<label>Preference KeyName:</label>
		<label class="InfoText">Default</label>

		<label>Version:</label>
		<label class="InfoText">Legacy</label>
	</div>

	<div class="Buttons">
		<button class="btn btn-primary" (click)="onSendNotification()">Send Email</button>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
